import { Controller } from '@hotwired/stimulus';
import { jquery } from 'utils/jquery';

export default class extends Controller {
  static values = {
    task: String,
    url: String
  };

  declare readonly taskValue: string;
  declare readonly urlValue: string;

  markReviewItem(event: Event): void {
    event.preventDefault();

    const button = event.target as HTMLButtonElement;
    button.disabled = true;
    button.textContent = 'Processing...';

    const $ = jquery();
    if (!$) {
      button.disabled = false;
      button.textContent = 'Confirm';
      alert('Error finishing. Try again.');
      return;
    }

    $.post(this.urlValue, { task: this.taskValue })
      .done(() => {
        window.location.reload();
      })
      .fail(() => {
        button.disabled = false;
        button.textContent = 'Confirm';
        alert('Error finishing. Try again.');
      });
  }
}
